module.exports = __webpack_public_path__ + "img/20180815_150609_103.ac04a977.jpg";